            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate >  
        <b-row style="width:100%">
          <b-col sm="12">
            <b-row  class="row-inputs">
              <sw-inputs
                inputTabla="info_aportes"
                inputCampo="id_list_forma"
                :cols="12"  :lg="3">
              </sw-inputs>
              <sw-inputs 
                v-if="dataForm[namePath].info_aportes.id_list_forma===1"
                inputTabla="info_aportes"
                inputCampo="id_list_cuentas"
                :cols="12"  :lg="3">
              </sw-inputs>
              <sw-inputs
                v-if="dataForm[namePath].info_aportes.id_list_forma===1"
                inputTabla="info_aportes"
                inputCampo="consignacion"
                :cols="12" :lg="3">
              </sw-inputs>   
              <b-col :md="3" :lg="3" style="padding-top: 30px;">
                {{fechaPago}}
                <b-form-checkbox
                  v-if="dataForm[namePath].info_aportes.id_list_ano!=fecha().fecha.anoHoy || dataForm[namePath].info_aportes.id_list_mes!=fecha().fecha.mesHoy"
                  @input="changeFecha"
                  v-model="fechaAdelantado"
                  name="checkbox-1"
                  >
                  1 día mes aporte
                </b-form-checkbox>
              </b-col>     
            </b-row>
          </b-col>
        </b-row>  
      </b-form>    
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
            <sw-saveform
              :index="dataIndex[namePath]"
              nameBtn="Registro"
              :invalid="invalid || dataForm[namePath].info_aportes.id_list_forma===2 || dataForm[namePath].info_aportes.id_list_forma===5"
              @save="save"
              >
            </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState, mapActions } from "vuex"
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    SwSaveform
  },
  props: {
    nameInactive: {
      type: String,
      default: ''
    }
  },
  computed: {    
    ...mapState({
    })
  },
  data() {
    return {
      fechaPago: null,
      getBackend: [],      
      fechaAdelantado:null,
    }
  },
  async created()
  {  
    this.fechaPago=this.fecha().fecha.minHoy
    await this.updateDataForm({ data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]]})
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  async destroyed(){
    await this.resetDataForm()
  },
  methods: {
    async save(emit)
    {
      await this.changeGlobal({state: 'saveConfig/capa', boolean: true})
      
      if(this.namePath==='aportes_descargar')
      {      
        
        if(this.fechaAdelantado)
        {  
          await this.updateDataForm({state: 'info_aportes/fecha', data: this.fechaPago})
        } 
        else 
        {
          this.updateDataForm({state:'info_aportes/fecha', data: this.fecha().fecha.minHoy})
        }        
        if(this.dataForm[this.namePath].info_aportes.servicios!=2)
        {        
          if(this.dataForm[this.namePath].info_aportes.tipo===0)
          {
            let dias=30
            let id_list_novedad=2
            let mes_periodo=parseInt(this.dataForm[this.namePath].info_aportes.id_list_mes)+1
            let ano_periodo=parseInt(this.dataForm[this.namePath].info_aportes.id_list_ano)       
            if(mes_periodo===13)
            {
              mes_periodo=1
              ano_periodo=ano_periodo+1
            }

            switch(this.dataForm[this.namePath].info_afiliacion.id_list_novedad)
            {
              case 3:
                mes_periodo=parseInt(this.dataForm[this.namePath].info_aportes.id_list_mes)
                ano_periodo=parseInt(this.dataForm[this.namePath].info_aportes.id_list_ano)
                dias=this.dataForm[this.namePath].info_afiliacion.dias
                id_list_novedad=this.dataForm[this.namePath].info_afiliacion.id_list_novedad
              break
            }

            let fechaArchivo=this.fecha().fecha.minHoy
            if(this.dataForm[this.namePath].info_aportes.id_list_mes.toString()!==this.fecha().fecha.mesHoy.toString() || this.dataForm[this.namePath].info_aportes.id_list_ano.toString()!==this.fecha().fecha.anoHoy.toString()) 
            {
              fechaArchivo=this.fecha(this.dataForm[this.namePath].info_aportes.id_list_ano+'-'+this.dataForm[this.namePath].info_aportes.id_list_mes+'-01').inicioLabores.servicios
            }
            
            let forAwait=[]
            for (let j = 0; j < this.dataForm[this.namePath].servicios_activos.length; j++) {
                if(id_list_novedad!==3)
                {
                  if(this.dataForm[this.namePath].archivo_plano.id_datos_razon===this.dataForm[this.namePath].info_afiliacion.id_datos_razon)
                  {   
                    forAwait.push(this.updateDataForm({ state: 'servicios_activos/'+j+'/mes_periodo', data:mes_periodo}))
                    forAwait.push(this.updateDataForm({ state: 'servicios_activos/'+j+'/ano_periodo', data:ano_periodo}))
                  }
                }            
            }

            await Promise.all(forAwait)
            
            if(this.dataForm[this.namePath].archivo_plano.id_datos_razon===this.dataForm[this.namePath].info_afiliacion.id_datos_razon)
            {              
              const await1 = this.updateDataForm({state:'info_afiliacion/id_list_novedad', data: id_list_novedad})
              const await2 = this.updateDataForm({state:'info_afiliacion/dias', data: dias})
              const await3 = this.updateDataForm({state:'info_afiliacion/mes_periodo', data: mes_periodo})
              const await4 = this.updateDataForm({state:'info_afiliacion/ano_periodo', data: ano_periodo})
              const await5 = this.updateDataForm({state:'archivo_plano/fecha', data: fechaArchivo})
              const await6 = this.updateDataForm({state:'aportes_registro/fecha', data: this.dataForm[this.namePath].info_aportes.fecha})        
              await Promise.all([await1,await2,await3,await4,await5,await6])
            }
            else 
            {
                const await5 = this.updateDataForm({state:'archivo_plano/fecha', data: fechaArchivo})
                const await6 = this.updateDataForm({state:'aportes_registro/fecha', data: this.dataForm[this.namePath].info_aportes.fecha})        
                await Promise.all([await5,await6])

            }
          }

          if(this.dataForm[this.namePath].info_aportes.tipo===1)
          {
            let data = await this.getData({ route: 'get_aporteslist', data:  this.dataForm[this.namePath].info_aportes.id})
            data.splice(0,0,{info_aportes: this.dataForm[this.namePath].info_aportes})
            for (let i = 1; i < data.length; i++) {
              let dias=30
              let id_list_novedad=2
              let mes_periodo=parseInt(this.dataForm[this.namePath].info_aportes.id_list_mes)+1
              let ano_periodo=parseInt(this.dataForm[this.namePath].info_aportes.id_list_ano)

              if(mes_periodo===13)
              {
                mes_periodo=1
                ano_periodo=ano_periodo+1
              }

              switch(data[i].info_afiliacion.id_list_novedad)
              {
                case 3:
                  mes_periodo=parseInt(data[i].info_aportes.id_list_mes)
                  ano_periodo=parseInt(ata[i].info_aportes.id_list_ano)
                  dias=data[i].info_afiliacion.dias
                  id_list_novedad=data[i].info_afiliacion.id_list_novedad
                break
              }
              
              let fechaArchivo=this.fecha().fecha.minHoy
              if(this.dataForm[this.namePath].info_aportes.id_list_mes.toString()!==this.fecha().fecha.mesHoy.toString() || this.dataForm[this.namePath].info_aportes.id_list_ano.toString()!==this.fecha().fecha.anoHoy.toString()) 
              {
                fechaArchivo=this.fecha(this.dataForm[this.namePath].info_aportes.id_list_ano+'-'+this.dataForm[this.namePath].info_aportes.id_list_mes+'-01').inicioLabores.servicios
              }
              
              for (let j = 0; j < data[i].servicios_activos.length; j++) {
                if(id_list_novedad!==3)
                {
                  data[i].servicios_activos[j].mes_periodo= mes_periodo
                  data[i].servicios_activos[j].ano_periodo= ano_periodo   
                }                     
              }

              data[i].info_afiliacion.id_list_novedad= id_list_novedad
              data[i].info_afiliacion.dias= dias
              data[i].info_afiliacion.mes_periodo=  mes_periodo
              data[i].info_afiliacion.ano_periodo=  ano_periodo
              data[i].archivo_plano.fecha=  fechaArchivo
              data[i].aportes_registro.fecha=  this.fecha().fecha.minHoy          
            }
            await this.updateDataPost({state: 'data', data: data})
          }
        } 
        else 
        {
            await this.updateDataPost({state: 'data', data: [{info_aportes: this.dataForm[this.namePath].info_aportes}]})
        }
      }

    await this.$emit('save', { save: emit.save, ftn: 'descargarAflFtn'})
    },
    changeFecha()
    {
      if(this.fechaAdelantado)
      {
        this.fechaPago=this.fecha(this.dataForm[this.namePath].info_afiliacion.ano_periodo+'-'+this.dataForm[this.namePath].info_afiliacion.mes_periodo+'-01').inicioLabores.servicios
      }
      else 
      {
        this.fechaPago=this.fecha().fecha.minHoy
      }
    }
  }
}
</script>
<style>
</style>